var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeletonBody"},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/reused-components/skeletonBody/SkeletonBody.vue